'use client'

import { getCookie } from 'shared/libs/storage/cookie'

import { useEffect, useState } from 'react'

import { IconButton } from 'shared/ui/iconButton'

import { commonApi } from 'shared/config/axios/commonApi'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './HeaderClose.module.scss'

export function HeaderClose() {
  const [isWebview, setIsWebview] = useState(false)

  useEffect(() => {
    setIsWebview(getCookie('isWebview') === 'true')
  }, [])

  const handleClose = async () => {
    await commonApi.closeWebview()
  }

  if (!isWebview) return null

  return (
    <IconButton
      onClick={handleClose}
      iconColor={globalStyles['--icon-secondary']}
      iconName="close"
      buttonType="squired"
      buttonColor="extra"
      iconSize="large"
      className={styles.close}
    />
  )
}
